<template>
	<div class='content'>
		<van-nav-bar
			   title="输入个人信息"
			   left-text=""
			   right-text=""
			   left-arrow
			   @click-left="onClickLeft"
			  @click-right="onClickRight"
			/>
	   <van-cell-group class="box">
		  <van-field
		  	  required
			  clickable
			  name="calendar"
			  v-model="timeDate"
			  label="游玩日期"
			  placeholder="点击选择日期"
			   left-icon="manager"
		      class='icon_color1'
			  @click="showCalendar = true"
			/>
			<van-calendar v-model="showCalendar" @confirm="onConfirm" />
		  <van-field
		    v-model="text"
		    clearable
		    label="游客姓名"
		    left-icon="manager"
		    required
		    placeholder="请输入姓名"
		    class='icon_color1'
		  />
		  <van-field
		    v-model="phone"
		    clearable
		    required
		    label="手机号码"
		    left-icon="phone-circle"
		    placeholder="请输入电话号码"
		     class='icon_color2'
		  />
		  <van-field
		    v-model="phone"
		    clearable
		    required
		    label="身份证号"
		    left-icon="phone-circle"
		    placeholder="请输入身份证"
		     class='icon_color2'
		  />
		</van-cell-group>
		<div class="box_visit">
			<p>
			    <van-icon name="bars" />
				订单：{{order}}
				</p>
			<p><van-icon name="bars" />
				金额：{{total}}
			</p>
			<p>
				<van-icon name="bars" />
				数量：{{numlist}}
			</p>
			
		</div>
	    
		<!--<van-tabbar v-model="active">
		  
		   <van-tabbar-item icon="home-o"><router-link to="/wx_ticketIndex" class="router" >购票首页</router-link></van-tabbar-item>
		   <van-tabbar-item icon="search"><router-link to="/wx_ticketOrder" class="router activerouter">我的订单</router-link></van-tabbar-item>
		   <van-tabbar-item icon="setting-o"><router-link to="/wx_ticketUser" class="router">个人中心</router-link></van-tabbar-item>
		</van-tabbar>-->
	<!--	<van-submit-bar  button-text="提交支付"   @submit="onSubmit">-->
		<van-submit-bar  button-text="提交预约"   @submit="onSubmit">
		  <template >
		  	 <div id="numlist" >
		  	    <span>数量:{{numlist}}</span>
			   	<span>合计:{{total}}</span>
	 	    	 
 	    	 </div>
		  </template>
		</van-submit-bar>
	</div>
</template>

<script>

  export default {
  data () {
    return {
    	 order:'',
    	 total:"",
    	 numlist:'',
    	 timeDate:'',
    	 currentDate: new Date(),
    	 phone:'',
   	     text: '',
	     message:'',
	     isLoadingShow: true,
    	 hide:false,
         loading: false,
	     finished: false,
         show: false,
         className: '',
         showCalendar: false,
	    }
    },
    mounted(){
    	this.time();
    },
	methods: {
	    onLoad() {
	        this.loading = false;
			this.finished = true;
	     },
	    onClickLeft(){
			this.$router.push({ path: "/wx_ticketList" });
		},
		onClickRight(){
			
		},
	    // 选项格式化函数
		 onSubmit(){},
        time(){
		      this.timeDate=this.dateFormat();
		      this.total = this.$route.query.total;
		      this.numlist= this.$route.query.numlist;
		      this.order="DD4484645454545445"
		      console.log(total) 
		      console.log(numlist) 
		    },
		    onConfirm(date) {
		 	  this.timeDate = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
		      this.showCalendar = false;
		    },    
		    dateFormat() {//获取当前时间
		    	var date=new Date();
		        var year=date.getFullYear();
		        var month= date.getMonth()+1<10 ? +(date.getMonth()+1) : date.getMonth()+1;
		        var day=date.getDate()<10 ? +date.getDate() : date.getDate();
		        //var hours=date.getHours()<10 ? "0"+date.getHours() : date.getHours();
		       // var minutes=date.getMinutes()<10 ? "0"+date.getMinutes() : date.getMinutes();
		        //var seconds=date.getSeconds()<10 ? "0"+date.getSeconds() : date.getSeconds();
		        return year+"-"+month+"-"+day
           },   
         showPopup () {
	      this.show = true
	      this.isLoadingShow = true
	      setTimeout(() => {
	        this.isLoadingShow = false
	      }, 500)
    },
		 
	}
}
</script>

<style>
	.icon_color1 i {
		color:#1989fa;
	}
	.icon_color2 i {
		color:#19c160;
	}
	.icon_color3 i {
		color:#07c160;
	}
	.icon_color4 i {
		color:#4fc08d;
	}
	.icon_color5 i {
		color:#2989fa;
	}
	.box_visit{
		width: 80%;
		margin-top:10px;
		margin-left: 10%;
		height: 100px;
		margin-bottom: 10px;
		border: 1px solid darkgray;
	}
</style>


// WEBPACK FOOTER //
// src/system/index/wechatlist/wx_ticketOrderpay.vue